import { CommonModule } from '@angular/common';
import {
  AfterViewChecked,
  Component,
  ElementRef,
  Inject,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { MatSpinnerOverlayComponent } from '../../components/mat-spinner-overlay/mat-spinner-overlay.component';
import { AcordosExistentesComponent } from '../acordos-existentes/acordos-existentes.component';
import {
  AcordoModel,
  AcordoRedeEspecialViewModel,
  CombustivelContrato,
  PayloadCriarAcordo,
} from '../rede-especial.interface';
import { RedeEspecialService } from '../rede-especial.service';

@Component({
  selector: 'app-editar-acordo-dialog',
  templateUrl: './editar-acordo-dialog.component.html',
  styleUrls: ['./editar-acordo-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
    CurrencyMaskModule,
    AcordosExistentesComponent,
    MatSpinnerOverlayComponent,
  ],
})
export class EditarAcordoDialogComponent implements AfterViewChecked {
  @ViewChildren('descontoInput') descontoInputs!: QueryList<ElementRef>;
  @ViewChildren('precoInput') precoInputs!: QueryList<ElementRef>;

  acordosSelecionados: AcordoRedeEspecialViewModel[];
  // Checa se houve mudanças em acordosSelecionados comparando com um snapshot inicial
  private acordosSelecionadosSnapshot: AcordoRedeEspecialViewModel[] = [];
  acordosExistentes: AcordoModel[] = [];
  msgAcordosExistentes: string = '';
  acordoSelecionado: AcordoRedeEspecialViewModel | null = null;
  combustiveis: CombustivelContrato[] = [];
  public acordoPrecoFixo: boolean = false;
  private shouldFocus = false;
  public precosComErro: boolean = false;
  public loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditarAcordoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: RedeEspecialService,
    private snackBar: SnackBarService
  ) {
    this.acordosSelecionados = data.acordos;
    this.combustiveis = data.combustiveis;
  }

  ngAfterViewChecked() {
    if (this.shouldFocus) {
      this.shouldFocus = false;
      setTimeout(() => {
        if (this.acordoPrecoFixo && this.precoInputs.length > 0) {
          this.precoInputs.first.nativeElement.focus();
        } else if (!this.acordoPrecoFixo && this.descontoInputs.length > 0) {
          this.descontoInputs.first.nativeElement.focus();
        }
      }, 100);
    }
  }

  verificarAcordoPrecoFixo(acordo: AcordoRedeEspecialViewModel): void {
    this.acordoPrecoFixo =
      acordo.dscTipoAcordoPreco.toUpperCase() === 'PREÇO FIXO';
  }

  selecionarAcordo(acordo: AcordoRedeEspecialViewModel): void {
    if (this.acordoSelecionado === acordo) {
      this.acordoSelecionado = null;
      this.acordoPrecoFixo = false;
    } else {
      this.acordoSelecionado = acordo;
      this.verificarAcordoPrecoFixo(acordo);
      this.shouldFocus = true;
    }
  }

  alterandoValorDesconto(acordo: AcordoRedeEspecialViewModel): void {
    if (acordo.vlrDescontoFixoAcordo !== null && acordo.vlrPrecoTela !== null) {
      acordo.vlrPrecoAcordo =
        acordo.vlrPrecoTela - acordo.vlrDescontoFixoAcordo;

      // desconto não pode ser maior que o preço de tela
      if (
        acordo.vlrDescontoFixoAcordo > acordo.vlrPrecoTela
        // || acordo.vlrDescontoFixoAcordo < 0
      ) {
        this.precosComErro = true;
      } else {
        this.precosComErro = false;
      }
    }
  }

  alterandoPrecoAcordo(acordo: AcordoRedeEspecialViewModel): void {
    if (acordo.vlrPrecoAcordo !== null && acordo.vlrPrecoTela !== null) {
      acordo.vlrDescontoFixoAcordo =
        acordo.vlrPrecoTela - acordo.vlrPrecoAcordo;

      // desconto não pode ser maior que o preço de tela
      if (
        acordo.vlrDescontoFixoAcordo > acordo.vlrPrecoTela ||
        acordo.vlrDescontoFixoAcordo < 0
      ) {
        this.precosComErro = true;
      } else {
        this.precosComErro = false;
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private getCodCombustivel(
    tipoCombustivel: string
  ): CombustivelContrato | undefined {
    const combustivel = this.combustiveis.find(
      (c) => c.combustivel.toUpperCase() === tipoCombustivel.toUpperCase()
    );
    return combustivel;
  }

  private async enviarPayloadAcordo(
    payload: PayloadCriarAcordo
  ): Promise<void> {
    this.loading = true;
    this.service.criarNovoAcordo(payload).subscribe({
      next: (res) => {
        console.log('Resposta do serviçeeeo:', res);
        if (!res.sucesso) {
          this.acordosExistentes = res.retorno;
          this.msgAcordosExistentes =
            res.mensagens[0] || 'Erro ao atualizar acordo.';

          this.snackBar.flashMessage(
            `${res.mensagens[0]}`,
            ['snackbar-error'],
            'Fechar',
            2
          );
        } else {
          console.log('Acordo atualizado com sucesso:', res);
          this.snackBar.flashMessage(
            `Acordo #${res.retorno} criado com sucesso!`,
            ['snackbar-success'],
            'Fechar',
            2
          );
          this.dialogRef.close();
        }
      },
      error: (err) => {
        this.snackBar.flashMessage(
          `Erro ao editar acordo`,
          ['snackbar-error'],
          'Fechar',
          2
        );
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  onConfirm(): void {
    for (const acordo of this.acordosSelecionados) {
      const acordoPrecoFixo =
        acordo.dscTipoAcordoPreco.toUpperCase() === 'PREÇO FIXO';

      const codCombustivel = this.getCodCombustivel(acordo.tipoCombustivel);

      if (codCombustivel) {
        const payload: PayloadCriarAcordo = {
          codFrota: acordo.codFrota,
          tipo: acordoPrecoFixo ? 2 : 5,
          combustivel: codCombustivel.codigoCombustivel,
          indCombustivel: codCombustivel.descricaoCombustivel,
          valorFixo:
            acordo.vlrPrecoAcordo != null
              ? parseFloat(acordo.vlrPrecoAcordo.toFixed(2))
              : null,
          valorDescontoEmReais:
            acordo.vlrDescontoFixoAcordo != null
              ? parseFloat(acordo.vlrDescontoFixoAcordo.toFixed(2))
              : null,
        };

        this.enviarPayloadAcordo(payload);
      } else {
        this.snackBar.flashMessage(
          `Combustível não encontrado para o tipo: ${acordo.tipoCombustivel}`,
          ['snackbar-error'],
          'Fechar',
          2
        );
        return;
      }
    }

    // this.dialogRef.close();
  }

  ngOnInit(): void {
    // Cria um snapshot profundo dos acordos selecionados ao iniciar
    this.acordosSelecionadosSnapshot = JSON.parse(
      JSON.stringify(this.acordosSelecionados)
    );
  }

  houveMudancasNosAcordosSelecionados(): boolean {
    // Compara o snapshot inicial com o estado atual
    return (
      JSON.stringify(this.acordosSelecionadosSnapshot) !==
      JSON.stringify(this.acordosSelecionados)
    );
  }

  // Calcula o preço do acordo baseado no preço de tela e desconto
  calcularPrecoAcordo(acordo: AcordoRedeEspecialViewModel): void {
    if (acordo.vlrPrecoTela !== null && acordo.vlrDescontoFixoAcordo !== null) {
      acordo.vlrPrecoAcordo =
        acordo.vlrPrecoTela - acordo.vlrDescontoFixoAcordo;
    }
  }
}
